module.exports = __webpack_public_path__ + "static/media/ServiceDateIcon.d484dc06.svg";